import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-4">
      <div className="text-center">
        <div className="w-24 h-24 flex items-center justify-center rounded-full bg-background-200 mx-auto mb-6">
          <i className="ri-movie-2-line text-5xl text-foreground-400"></i>
        </div>
        <h1 className="font-heading text-6xl md:text-8xl font-bold text-foreground-200 mb-4">404</h1>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
          页面未找到
        </h2>
        <p className="text-foreground-500 mb-8 max-w-md mx-auto">
          抱歉，您要访问的页面不存在或已被移除。请检查链接是否正确，或返回首页继续浏览。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}